import React, { useState } from "react";
import { theme } from "../utils/theme";
import { Box, Button, Menu, MenuItem, Tooltip } from "@mui/material";
import { Settings } from "lucide-react";

// Define props interface
interface DataLayerSelectorProps {
  selectedLayer: string;
  setSelectedLayer: (layer: string) => void;
}

function DataLayerSelector({
  selectedLayer,
  setSelectedLayer,
}: DataLayerSelectorProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (layer?: string) => {
    if (layer) setSelectedLayer(layer);
    setAnchorEl(null);
  };

  return (
    <Box
      className="leaflet-top leaflet-right"
      sx={{
        position: "absolute",
        top: "2vh",
        right: "0.8vw",
        zIndex: 1000,
        pointerEvents: "auto",
        background: theme.palette.grey[200],
        borderRadius: "5%",
        border: `0.5px solid ${theme.palette.grey[400]}`,
      }}
    >
      <Tooltip title="Select Data Layer">
        <Button onClick={handleClick} sx={{ p: 0.5 }}>
          <Settings
            style={{ marginRight: "8px" }}
            color={theme.palette.grey[600]}
          />
          {selectedLayer} {/* Show selected layer */}
        </Button>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        sx={{ mt: 0.5, color: theme.palette.grey[600] }}
      >
        {["FM", "cf1", "RH", "TempC"].map((layer) => (
          <MenuItem key={layer} onClick={() => handleClose(layer)}>
            {layer}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export default DataLayerSelector;
